import { Tag } from 'antd';

/** Risk band chip — colour paired with the "Risk:" text so colour is never the sole signal. */
export function RiskChip({ band }: { band?: string | null }) {
  if (!band) return null;
  const b = band.toUpperCase();
  const color =
    b.includes('HIGH') || b.includes('CRIT') || b.includes('SEVERE')
      ? 'error'
      : b.includes('MED') || b.includes('ELEV')
        ? 'warning'
        : b.includes('LOW') || b.includes('STANDARD')
          ? 'success'
          : 'default';
  return (
    <Tag bordered={false} color={color} title={`Risk band ${band}`}>
      Risk: {band}
    </Tag>
  );
}

/** Entity lifecycle status chip. */
export function EntityStatusChip({ status }: { status?: string | null }) {
  if (!status) return null;
  return (
    <Tag bordered={false} title={`Status ${status}`}>
      {status}
    </Tag>
  );
}
